import { keyframes } from "@busbud/design-system-components/dist/styles/keyframes";

import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { styles, colors, spacing } = theme.busbud;
  const dot_size = spacing(1);
  const slideComponent = keyframes`
  0% {
    opacity: 0;
    transform: translate3d(${spacing(3)}, 0, 0);
  }
  100% {
    opacity: 1;
  }
`;

  return {
    container: {
      padding: spacing(0, 3)
    },
    item: {
      animation: `${slideComponent} 0.3s ease-in-out .15s backwards`,
      textAlign: "center",
      minHeight: spacing(32) // avoid height diff on slide when a text is longer than another
    },
    dot: {
      cursor: "pointer",
      width: dot_size,
      height: dot_size,
      borderRadius: styles.rounding.circle,
      backgroundColor: colors.accent.primary[200],
      "&:hover": {
        backgroundColor: colors.accent.primary[400]
      }
    },
    selected: {
      backgroundColor: colors.accent.primary[500]
    }
  };
});
